export default (value: number): string =>
  value > 1 ? `${value}px` : `${value * 100}%`;
